import { first } from "@pdfking/rfunc"

import selector from "../dom/selector"

export default (element, behaviour) => {
  const el = first(selector(element || window.location.hash || "body"))
  return el ? el.scrollIntoView(behaviour) : null
}
